import { withCardTransitionContext } from './WithCardTransitionContext';

// withCardTransitionContext > withExpose > withBuildingBlock > withAnimation > component

export default withCardTransitionContext;
